import { v4 as uuidV4 } from "uuid";
import { getLocalStorageOneItem, setLocalStorageOneItem } from "./localStorage";
import { LOCAL_STORAGE_CLIENT_UUID, LOCAL_STORAGE_NATIVE_DEVICE_ID } from "constants/localStore";

const generatePersistedDeviceUUID = () => {
  const nativeDeviceID = getLocalStorageNativeDeviceID() || "";

  const persistedUUID = getLocalStorageOneItem(LOCAL_STORAGE_CLIENT_UUID);
  let deviceUUID: string = "";

  if (!persistedUUID) {
    deviceUUID = uuidV4();
    setLocalStorageOneItem(LOCAL_STORAGE_CLIENT_UUID, deviceUUID);
  } else {
    deviceUUID = persistedUUID;
  }

  if (!!nativeDeviceID) {
    return nativeDeviceID;
  }

  return deviceUUID;
};

const setLocalStorageNativeDeviceID = (nativeDeviceID: string = "") => {
  setLocalStorageOneItem(LOCAL_STORAGE_NATIVE_DEVICE_ID, nativeDeviceID);
};

const getLocalStorageNativeDeviceID = () => {
  return getLocalStorageOneItem(LOCAL_STORAGE_NATIVE_DEVICE_ID);
};

export { generatePersistedDeviceUUID, setLocalStorageNativeDeviceID, getLocalStorageNativeDeviceID };
